import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import apiClient from '../api/config';
import { ROUTES } from "../routes";
import { getDefaultHomeRoute, isInternalUser } from "../utils/clientMsp";

export default function AzureCallback() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { login } = useAuth();
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const handleCallback = async () => {
      const redirectPath = searchParams.get('redirect');
      
      try {
        await new Promise(resolve => setTimeout(resolve, 500));
        
        let response;
        let userData = null;
        
        try {
          response = await apiClient.get('/api/auth/azure-verify/');
          console.log('Azure verify response:', response.data);
          if (response.data && response.data.success) {
            userData = response.data.user;
          }
        } catch (verifyError) {
          console.log('Azure verify failed, trying user endpoint:', verifyError);
          try {
            response = await apiClient.get('/api/auth/user/');
            console.log('User endpoint response:', response.data);
            if (response.data && response.data.success) {
              userData = response.data.user;
            }
          } catch (userError) {
            console.error('Both endpoints failed:', userError);
            throw verifyError;
          }
        }
        
        if (userData) {
          console.log('User data received:', userData);
          login(userData);
          
          const finalPath = isInternalUser(userData)
            ? (redirectPath || ROUTES.SUPERADMIN_OVERVIEW)
            : getDefaultHomeRoute(userData);
          
          console.log('Redirecting to:', finalPath);
          setTimeout(() => {
            navigate(finalPath, { replace: true });
          }, 200);
        } else {
          throw new Error('No user data received');
        }
      } catch (err) {
        console.error('Azure callback error:', err);
        console.error('Error response:', err.response);
        const errorMsg = err.response?.data?.error || err.message || 'Authentication failed. Please try again.';
        setError(errorMsg);
        setTimeout(() => {
            window.location.href = ROUTES.LOGIN;
        }, 2000);
      } finally {
        setLoading(false);
      }
    };

    handleCallback();
  }, [searchParams, login]);

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        flexDirection: 'column',
        gap: '1rem'
      }}>
        <div style={{
          width: '40px',
          height: '40px',
          border: '4px solid #f3f3f3',
          borderTop: '4px solid #6f42c1',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite'
        }}></div>
        <p style={{ color: 'var(--color-text-light)', fontSize: '14px' }}>Completing authentication...</p>
        <style>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        flexDirection: 'column',
        gap: '1rem',
        padding: '2rem'
      }}>
        <div style={{
          background: 'rgba(239,68,68,0.12)',
          color: '#ef4444',
          padding: '1rem 1.5rem',
          borderRadius: '10px',
          fontSize: '14px',
          textAlign: 'center',
          maxWidth: '400px'
        }}>
          {error}
        </div>
        <p style={{ color: 'var(--color-text-light)', fontSize: '12px' }}>
          Redirecting to login...
        </p>
      </div>
    );
  }

  return null;
}

